export * from './src/pipes.module';
